import '../../template-quick-trade/calculator.js';
import './TagCloud/index.js';
import TagCloud from "./TagCloud/index.js";

const init = () => {

    const redirectTarget = "https://coinmate.io/cs/sign-up?clickid=2207001";

    // template-quick-trade
    const buttonBegin = document.getElementById("cta-button-begin");
    if (buttonBegin) {
        buttonBegin.addEventListener("click", (event) => {
            event.preventDefault();
            const value = document.getElementById("amount").value;
            dataLayer.push({
                'event': 'LPQuickTrade',
                'param1': 'QTStartInvest',
                'value': value
            });
            setTimeout(function () {
                window.location.href = redirectTarget
            }, 200);
        });
    }

    // template-quick-trade
    const buttonInvest = document.getElementById("cta-invest");
    if (buttonInvest) {
        buttonInvest.addEventListener("click", (event) => {
            event.preventDefault();
            const currency = document.getElementById("currency").value;
            const value = document.getElementById("amount").value;
            dataLayer.push({
                'event': 'LPQuickTrade',
                'param1': 'QTInvest',
                'param2': currency,
                'value': value
            });
            setTimeout(function () {
                window.location.href = redirectTarget
            }, 200);
        });
    }

    // Mobile menu switcher
    const cmOpenMenu = document.querySelector(".cm-open-menu");
    const cmCloseMenu = document.querySelector(".cm-close-menu");
    if (cmOpenMenu || cmCloseMenu) {
        cmOpenMenu.addEventListener("click", () => {
            const cmMenu = document.querySelector(".cm-menu");
            cmMenu.toggleAttribute("hidden");
        });
        cmCloseMenu.addEventListener("click", () => {
            const cmMenu = document.querySelector(".cm-menu");
            cmMenu.toggleAttribute("hidden");
        });
    }

    // Form recaptcha
    let form = document.getElementById('form-box');
    if (typeof (form) != 'undefined' && form != null) {
        document.querySelector("#form-box").addEventListener("submit", function (event) {
            event.preventDefault();
            grecaptcha.reset();
            grecaptcha.execute();
        });

        function onSubmit(token) {
            document.getElementById("form-box").submit();
        }
    }


    // Scroll to anchor
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const href = this.getAttribute('href');
            if (href) {
                document.querySelector(href).scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });


// function elementInViewport(el) {
//     var top = el.offsetTop;
//     var left = el.offsetLeft;
//     var width = el.offsetWidth;
//     var height = el.offsetHeight;
//
//     while(el.offsetParent) {
//         el = el.offsetParent;
//         top += el.offsetTop;
//         left += el.offsetLeft;
//     }
//
//     return (
//         top < (window.pageYOffset + window.innerHeight) &&
//         left < (window.pageXOffset + window.innerWidth) &&
//         (top + height) > window.pageYOffset &&
//         (left + width) > window.pageXOffset
//     );
// }

    // Block - Chapters
    const postChapters = () => {
        const target = document.getElementById("chapters");
        if (!target) return;

        let h2 = false;
        if (target.hasAttribute("data-heading-type-h2")) h2 = true;

        let h3 = false;
        if (target.hasAttribute("data-heading-type-h3")) h3 = true;

        let headings;

        if (h2 && h3) {
            headings = document.querySelectorAll(".editor h2, .editor h3");
        } else if (h2) {
            headings = document.querySelectorAll(".editor h2");
        } else if (h3) {
            headings = document.querySelectorAll(".editor h3");
        } else {
            document.querySelector(".chapters").remove();
            return;
        }
        if (headings.length === 0) {
            document.querySelector(".chapters").remove();
            return;
        }

        let tpl = "";
        headings.forEach((heading, index) => {
            heading.setAttribute("data-target", index.toString());
            tpl += `<div class='chapters__${heading.localName}' data-scroll-to='${index}'>`;
            tpl += heading.outerText
            tpl += "</div>";
        })
        target.innerHTML = tpl;

        const targets = document.querySelectorAll("[data-scroll-to]");
        targets.forEach((target) => {
            target.addEventListener("click", () => {
                const targetIndex = target.getAttribute("data-scroll-to");
                document.querySelector(`[data-target='${targetIndex}']`).scrollIntoView({
                    behavior: 'smooth'
                });
            })
        })

    }
    postChapters();


    // Global - Accordion
    const accordion = ({mainBlockSelector, rowsSelector, clickSelector, showSelector, rowActiveCLass}) => {

        const mainBlocks = document.querySelectorAll(mainBlockSelector);

        mainBlocks.forEach((mainBlock) => {
            const accordions = mainBlock.querySelectorAll(rowsSelector);
            if (!accordions) return false;

            const openAccordion = (accordion) => {
                const content = accordion.querySelector(showSelector);
                accordion.classList.add(rowActiveCLass);
                content.style.maxHeight = content.scrollHeight + "px";
            };

            const closeAccordion = (accordion) => {
                const content = accordion.querySelector(showSelector);
                accordion.classList.remove(rowActiveCLass);
                content.style.maxHeight = null;
            };

            accordions.forEach((accordion) => {
                const intro = accordion.querySelector(clickSelector);
                const content = accordion.querySelector(showSelector);

                intro.onclick = () => {
                    if (content.style.maxHeight) {
                        closeAccordion(accordion);
                    } else {
                        accordions.forEach((accordion) => closeAccordion(accordion));
                        openAccordion(accordion);
                    }
                };
            });
        })

    }


    // Block - FAQ
    const blockFaq = () => {
        accordion({
            mainBlockSelector: ".block-faq",
            rowsSelector: ".block-faq__row",
            clickSelector: ".block-faq__row__title",
            showSelector: ".block-faq__row__content",
            rowActiveCLass: "block-faq__row--active"
        });
    }
    blockFaq();


    // Block - Manual URL
    const blockManualUrl = () => {
        accordion({
            mainBlockSelector: ".block-manual-url",
            rowsSelector: ".block-manual-url__inner",
            clickSelector: ".block-manual-url__title",
            showSelector: ".block-manual-url__content",
            rowActiveCLass: "block-manual-url__inner--active"
        });
    }
    blockManualUrl();


    // Block - Question / Answer
    const blockQuestionAnswer = () => {
        const blocks = document.querySelectorAll(".block-question-answer");
        if (blocks) {
            blocks.forEach((block) => {

                const question = block.querySelector(".block-question-answer__question");
                const answer = block.querySelector(".block-question-answer__answer");

                block.style.removeProperty("height");
                question.style.removeProperty("height");
                answer.style.removeProperty("height");

                const questionHeight = question.offsetHeight;
                const answerHeight = answer.offsetHeight;

                const height = questionHeight >= answerHeight ? questionHeight : answerHeight;

                question.style.height = height + "px";
                answer.style.height = height + "px";
                block.style.height = height + "px";
            });
        }
    }
    blockQuestionAnswer();
    window.addEventListener("resize", () => {
        blockQuestionAnswer();
    })


    // Block - Content show more
    const blockContentShowMore = () => {
        const blocks = document.querySelectorAll(".block-show-more");
        blocks.forEach((block) => {
            const toggle = block.querySelector(".block-show-more__toggle");
            const moreContent = block.querySelector(".block-show-more__more-content");
            toggle.addEventListener("click", () => {
                toggle.classList.toggle("block-show-more__toggle--active");
                moreContent.classList.toggle("block-show-more__more-content--active");
            });
        })
    }
    blockContentShowMore();

    // Academy - Categories selector
    const acdCategoriesSelector = () => {
        const categories = document.querySelector(".cpp-categories");
        if (!categories) return;

        const activeCategory = document.querySelector(".cpp-category-tag__active");
        const currentCategory = document.querySelector(".cpp-current-category");
        currentCategory.prepend(activeCategory.cloneNode(true));

        currentCategory.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            categories.classList.toggle("cpp-categories--active");
        });

        const checkMinWidth = () => {
            if (window.innerWidth >= 768) {
                categories.classList.remove("cpp-categories--active");
            }
        }

        window.onresize = () => {
            if (window.innerWidth >= 768) {
                checkMinWidth();
            }
        };

        // close
        window.addEventListener("click", () => {
            categories.classList.remove("cpp-categories--active");
        });
    }
    acdCategoriesSelector();

    // Currency - Banner - Model example
    const crcBannerModelExample = () => {


        function numberWithSpaces(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }

        const animator = {};

        animator.animateNum = function (el, currVal, endVal, endCur) {
            let elapsedTime = 0, //The elapsed time (used for animation)
                fps = 1000 / 16, //60 fps (can be 16)
                lastTime = Date.now(), //The last time
                duration = 2000, //How fast it should animate
                increment = ((endVal - currVal) / duration) * fps, //Work out the increment amount
                update = null; //Where we attach the interval

            // Set up the interval
            update = setInterval(function () {
                elapsedTime = Date.now() - lastTime; //Work out the elapsed time

                //Check the elapsed time has not passed the duration
                if (elapsedTime < duration) {
                    //Do the animation
                    currVal += increment; //Increase the value
                    el.innerHTML = numberWithSpaces(parseFloat(currVal).toFixed(0) + endCur);
                } else {
                    el.innerHTML = numberWithSpaces(parseFloat(endVal).toFixed(0) + endCur); //Update it to the last value
                    clearInterval(update); //Clear the interval
                }
            }, fps);
        };


        const banner = document.querySelector(".crc-banner-model-example");

        if (!banner) return false;

        const bYear = document.querySelector(".crc-banner-model-example__year");
        const bPercent = document.querySelector(".crc-banner-model-example__percent");
        const bPrice = document.querySelector(".crc-banner-model-example__price");

        const animation = () => {

            bYear.innerHTML = bannerModelExampleData.year1.title;
            animator.animateNum(bPercent, 0, bannerModelExampleData.year1.percent, "%");
            animator.animateNum(bPrice, 10000, bannerModelExampleData.year1.price, " Kč");
            bPercent.classList.remove("crc-banner-model-example__percent--size-3");
            bPercent.classList.add("crc-banner-model-example__percent--size-1");

            setTimeout(function () {

                bYear.innerHTML = bannerModelExampleData.year2.title;
                animator.animateNum(bPercent, bannerModelExampleData.year1.percent, bannerModelExampleData.year2.percent, "%");
                animator.animateNum(bPrice, bannerModelExampleData.year1.price, bannerModelExampleData.year2.price, " Kč");

                bPercent.classList.remove("crc-banner-model-example__percent--size-1");
                bPercent.classList.add("crc-banner-model-example__percent--size-2");

                setTimeout(function () {

                    bYear.innerHTML = bannerModelExampleData.year3.title;
                    animator.animateNum(bPercent, bannerModelExampleData.year2.percent, bannerModelExampleData.year3.percent, "%");
                    animator.animateNum(bPrice, bannerModelExampleData.year2.price, bannerModelExampleData.year3.price, " Kč");

                    bPercent.classList.remove("crc-banner-model-example__percent--size-2");
                    bPercent.classList.add("crc-banner-model-example__percent--size-3");


                }, 4000);

            }, 4000);

        }

        function timeout() {
            setTimeout(function () {
                animation();
                timeout();
            }, 16000);
        }

        animation();
        timeout();


    }
    crcBannerModelExample();

    // Currency - Banner - Stats
    const crcBannerStats = () => {

        const blink = (target, time, elements) => {
            const inst = setInterval(change, time);
            let counter = 0;

            function change() {
                target.innerHTML = elements[counter];
                counter++;
                if (counter >= elements.length) {
                    counter = 0;
                    // clearInterval(inst);
                }
            }

            change();
        }

        const capital = document.querySelector(".crc-banner-stats__capital");
        const max = document.querySelector(".crc-banner-stats__max");

        if (capital && max) {
            blink(capital, 6000, bannerStats.capital);
            blink(max, 6000, bannerStats.max);
        }


    }
    crcBannerStats()

    // Dictionary
    const dictionary = () => {

        const posts = document.querySelectorAll("[data-dictionary-item]");
        const alphabet = document.querySelectorAll("#dictionary-alphabet > div");

        alphabet.forEach(char => {
            char.addEventListener("click", () => {
                const charValue = char.innerHTML.toLowerCase();

                // posts.forEach(post => {
                //     post.classList.add("hidden");
                // })
                // hideAll();
                // const filteredItems = Array.from(posts).filter(item => item.dataset.dictionaryItem === charValue);
                // filteredItems.forEach(item => {
                //     item.classList.remove("hidden");
                // })

                const target = document.getElementById(`letter-target-${charValue}`);
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            })

        });


    }
    dictionary();

    // Homepage
    const homepage = () => {


        const globalSettings = {
            slidesPerView: 1,
            loop: true, // todo allow only is slides is more than slidesPerView * 2
        }

        const posts2onRow = {
            breakpoints: {
                640: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                },
                768: {
                    spaceBetween: 40,
                    slidesPerView: 2,
                }
            }
        }

        const posts3onRow = {
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
        }


        const swiperCryptoAcademy = new Swiper('.swiperCryptoAcademy', {
            ...globalSettings,
            ...posts2onRow,
            navigation: {
                nextEl: '.swiperCryptoAcademy-button-next',
                prevEl: '.swiperCryptoAcademy-button-prev',
            },
        })
        const swiperCryptoPosts = new Swiper('.swiperCryptoPosts', {
            ...globalSettings,
            ...posts3onRow,
            navigation: {
                nextEl: '.swiperCryptoPosts-button-next',
                prevEl: '.swiperCryptoPosts-button-prev',
            },
        })
        const swiperCryptoNews = new Swiper('.swiperCryptoNews', {
            ...globalSettings,
            ...posts3onRow,
            navigation: {
                nextEl: '.swiperCryptoNews-button-next',
                prevEl: '.swiperCryptoNews-button-prev',
            },
        })



        // get from data .tag-cloud data-tags attribute
        const tags = document.querySelector(".tag-cloud")?.getAttribute("data-tags");
        if (!tags) return;

        const tagsDecoded = JSON.parse(tags);
        const titles = tagsDecoded.map(tag => tag.title);

        // tag cloud
        // https://www.cssscript.com/animated-sphere-tag-cloud/
        // const titles = [
        //     'JavaScript', 'CSS', 'HTML',
        //     'Angualr', 'VueJS', 'React',
        //     'Python', 'Go', 'Chrome',
        //     'Edge', 'Firefox', 'Safari',
        // ];


        const tagCloud = TagCloud('.tag-cloud', titles, {
            // radius in px
            radius: 100,
            // animation speed
            // slow, normal, fast
            maxSpeed: 'slow',
            initSpeed: 'slow',
            // 0 = top
            // 90 = left
            // 135 = right-bottom
            direction: 90,

            // interact with cursor move on mouse out
            keep: true,
            useContainerInlineStyles: true,
            useItemInlineStyles: true,
            containerClass: 'tagcloud',
            itemClass: 'tagcloud--item'

        });

    }
    homepage();

    // Countdown
    const blockCountdown = () => {

        function sklonovani(value, type) {
            let word;
            switch (type) {
                case "day":
                    word = value === 1 ? "den" : (value >= 2 && value <= 4) ? "dny" : "dní";
                    break;
                case "hour":
                    word = value === 1 ? "hodina" : (value >= 2 && value <= 4) ? "hodiny" : "hodin";
                    break;
                case "minute":
                    word = value === 1 ? "minuta" : (value >= 2 && value <= 4) ? "minuty" : "minut";
                    break;
                case "second":
                    word = value === 1 ? "vteřina" : (value >= 2 && value <= 4) ? "vteřiny" : "vteřin";
                    break;
            }
            return word;
        }

        // Query all countdown blocks
        const countdowns = document.querySelectorAll('.block-countdown');

        countdowns.forEach(function(countdown){

            // Start timer for the countdown block
            const interval = setInterval(updateCounter, 1000);
            // Get end date and expiration text for each countdown block
            const countdownEndDate = countdown.dataset.endDate;

            function updateCounter() {
                const now = new Date().getTime();
                const target = new Date(countdownEndDate).getTime();
                const remaining = target - now;

                const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
                const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

                countdown.querySelector('.days').innerHTML = days < 10 ? '' + days : days;
                countdown.querySelector('.hours').innerHTML = hours < 10 ? '' + hours : hours;
                countdown.querySelector('.minutes').innerHTML = minutes < 10 ? '' + minutes : minutes;
                countdown.querySelector('.seconds').innerHTML = seconds < 10 ? '' + seconds : seconds;

                countdown.querySelector('.block-countdown__text--days').innerHTML = sklonovani(days, "day");
                countdown.querySelector('.block-countdown__text--hours').innerHTML = sklonovani(hours, "hour");
                countdown.querySelector('.block-countdown__text--minutes').innerHTML = sklonovani(minutes, "minute");
                countdown.querySelector('.block-countdown__text--seconds').innerHTML = sklonovani(seconds, "second");

                // If time is up, clear interval and display expiration text
                if (remaining < 0) {
                    clearInterval(interval);
                    if (countdown.dataset.expirationText) {
                        countdown.innerHTML = '<div class="block-countdown__has-expired">' + countdown.dataset.expirationText + '</div>';
                    }
                    else {
                        countdown.classList.add("hidden");
                    }
                }
            }
            updateCounter();
        });

    }
    blockCountdown();


}

init();
